function EMAVideoCallStatus() {
    "use strict";

    this.__type = 'EMAVideoCallStatus:www.veritracks.com';
    this.Id = "";
    this.AppUserId = "";
    this.AgentId = -1;
    this.Status = -1;// 1- success, 2 - failed , 3 - Missed
    this.Duration = -1;
    this.AgentName = "";
}
if (typeof exports !== 'undefined') {
    module.exports = EMAVideoCallStatus;
}